var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"home-container"},[_c('HeadBox',{on:{"openAffix":_vm.openAffix}}),_c('SwiperCard',{attrs:{"is-animate":true,"type":'home'}}),_c('BarnchScroll'),_c('FootBox'),_c('ContactAffix',{ref:"ContactAffix"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }